import React  from 'react'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useDispatch } from "react-redux";
import { closeRoleDialog } from '../state/role/actions';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';

const RoleModal = ({
    open,
    value,
    setRoleData,
    handleFormData
}) => {
    const dispatch = useDispatch();
    // Function to set values of the Form Fields
    const changeHandler = (e) => {
        setRoleData((prevState) =>
        ({...prevState, [e.target.name]: e.target.value }));
    };

     // Function to handle the close of Form popup
    const handleClose = (event, reason) => {
        setRoleData({
            name : '',
            role_type : '',
            description:'',
        });
        dispatch(closeRoleDialog());
    };

    return (
        <Dialog fullWidth maxWidth="sm" open={open}>
            <DialogTitle>Add New Role</DialogTitle>
            <DialogContent dividers> 
                <TextField  
                    margin="dense"
                    id="name"
                    label="Role Name"
                    name="name"
                    fullWidth
                    value={value.name}
                    onChange={changeHandler}
                    error={value.name === ""}
                    helperText={value.name === "" ? "Required Field!" : " "}
                />
                <FormControl sx={{width:'100%'}} margin="dense">
                    <InputLabel id="demo-simple-select-standard-label">Role Type</InputLabel>
                    <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        sx={{ "&:focus": {
                            backgroundColor: "#ffffff"
                            } 
                        }}
                        label="Role Type" 
                        defaultValue=""
                        value={value.role_type || ''}
                        onChange={changeHandler}
                        name="role_type"
                        error={value.role_type === "" || typeof value?.role_type === 'undefined'}
                    >
                        <MenuItem value="">Select Role</MenuItem>
                        <MenuItem value="1">Rehlink Sphere Portal</MenuItem>
                        <MenuItem value="2">Rehlink Mobile App</MenuItem>
                    </Select>
                    <FormHelperText sx={{color:"#d32f2f"}} >{value.role_type === "" || typeof value.role_type === 'undefined' ? "Required Field!" : " "}</FormHelperText>
                </FormControl>
                <TextField 
                    label="Description" 
                    id="description" 
                    name="description"
                    multiline
                    rows={4}
                    fullWidth
                    sx={{paddingBottom:2}}
                    value={value.description}
                    onChange={changeHandler}
                    error={value.description === ""}
                    helperText={value.description === "" ? "Required Field!" : " "}
                />
            </DialogContent>
            <DialogActions>
                <Button  variant="contained"
                    size="medium"
                    color="primary" 
                    onClick={handleFormData}
                >Submit</Button>
                <Button  variant="contained"
                    size="medium"
                    color="error" onClick={handleClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    )
}

export default RoleModal
